<template>
  <div id="app">
    <component
      :is="headerComponent"
      @changeLanguage="changeLanguage"
      :yy="yy"
    ></component>
    <router-view :key="lanageKey" />
    <scroll-top />
    <Footer />
  </div>
</template>
<script>
import ScrollTop from "@/components/scrollTop.vue";
import HeaderNav from "@/components/headerNav.vue";
import HeaderNavDep from "@/components/headerNavDep.vue";
import Footer from "@/components/footer.vue";
import i18n from "@/../public/i18n";
export default {
  data() {
    return {
      lanageKey: "en",
      yy: false,
    };
  },
  components: {
    HeaderNav,
    Footer,
    ScrollTop,
    HeaderNavDep,
  },
  computed: {
    headerComponent() {
      return this.$route.meta.header || HeaderNav; // 默认头部
    },
  },
  watch: {
    $route(to, from) {
      let path = to.path;
      path = path.substring(1);
      if (path == "shopHome") {
        this.yy = true;
      } else {
        this.yy = false;
      }
    },
  },
  methods: {
    changeLanguage(lang) {
      i18n.changeLanguage(lang); // 调用 i18n 实例的方法来更改语言
      // window.alert( lang);
      this.lanageKey = lang;
      this.$forceUpdate();
      console.log("切换语言为：" + lang, i18n);
    },
  },
};
</script>

<style>
#app {
  /* font-family: 'Roboto-Black',Avenir, Helvetica, Arial, sans-serif; */
  font-family: "Roboto-Regular";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* max-width: 1600px; */
}

nav {
  padding: 30px;
}

nav a {
  font-family: "Roboto-Black";
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
section {
  opacity: 0;
  transition: all 1.5s;
}
</style>
